import {Component, Input, OnChanges, OnInit,} from '@angular/core';
import {CoreComponent} from "../../../../../core/component/core-component/core.component";
import {
  ContractInsurableObjectType,
  ContractsRequestDto,
  ContractsRuntimeObjectDto,
  ContractStatusEnum
} from "../../../types/contracts.types";
import {Router} from "@angular/router";
import {MessageService} from "primeng/api";
import {InsurableObjectService} from "../../../api/insurable-object.service";
import {ImageDto} from "../../../../../core/interfaces/core.types";
import {DashboardService} from "../../../../../ds/service/dashboard.service";
import {UserApiService} from "../../../../user/api/user-api.service";
import {ImageHelper} from "../../../../../core/helper/image-helper";


@Component({
  selector: 'app-insurable-object-update',
  templateUrl: 'insurable-object-update.component.html',
  styleUrls: ['insurable-object-update.component.scss']
})
export class InsurableObjectUpdateComponent extends CoreComponent implements OnInit, OnChanges {

  @Input() insurableObject?: ContractsRuntimeObjectDto;

  imageSrc?: string;
  tempImageSrc?: string;
  imageChangedEvent: any = '';
  showImageCropperDialog = false;
  croppedImage: any = '';



  constructor(
    protected dashboardService: DashboardService,
    private messageService: MessageService,
    protected router: Router,
    protected insurableObjectService: InsurableObjectService,
    protected userApiService: UserApiService,) {
    super();
  }


  override ngOnInit() {

    this.refreshComponent();
  }

  refreshComponent() {
    this.initialized = true;
  }


  protected createInitialRequest(): ContractsRequestDto {

    return {
      includeContractPartnerData: true,
      includeContractDetails: false,
      includeInsurableObjects: true,
      filterStatusIds: [ContractStatusEnum.active, ContractStatusEnum.pending]
    };

  }

  onUploadHandler(event: any) {

    const file = event.target.files?.[0];
    // if (file?.size > 2 * 1024 * 1024) {
    //   this.messageService.add({
    //     severity: 'warn',
    //     summary: 'Zu groß',
    //     detail: 'Die Datei darf nicht größer als 2MB sein.'
    //   });
    //   return;
    // }

    this.imageChangedEvent = event;
    this.showImageCropperDialog = true;
  }

  imageCropped(event: any): void {
    this.croppedImage = event.base64;

    if (!this.croppedImage && event.blob) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.croppedImage = reader.result;
      };
      reader.readAsDataURL(event.blob);
    }

    this.tempImageSrc = event.objectUrl;
  }

  uploadCroppedImage() {
    if (!this.croppedImage || typeof this.croppedImage !== 'string' || !this.croppedImage.includes(',')) {
      this.messageService.add({
        severity: 'error',
        summary: 'Fehler',
        detail: 'Kein gültiges Bild vorhanden.'
      });
      return;
    }

    if (!this.croppedImage?.startsWith('data:image/')) {
      console.error('Invalid image format:', this.croppedImage);
      this.messageService.add({
        severity: 'error',
        summary: 'Fehler',
        detail: 'Das Bildformat ist ungültig oder unvollständig.'
      });
      return;
    }

    this.insurableObject!.imageUrl = this.croppedImage!;
    this.showImageCropperDialog = false;
    ImageHelper.resizeBase64Image(this.croppedImage, 500, 500).then(resizedImage => {
      const blob = this.dataURItoBlob(resizedImage);
      const file = new File([blob], "cropped-image.png", {type: blob.type});

      this.convertFileToBase64AndGetType(file).then(document => {
        const dto: ImageDto = {
          dataBase64: document.fileBase64,
          mimeType: document.fileBase64MimeType
        };

        const id = this.insurableObject?.id;
        if (!id) return;

        console.log(this.insurableObject?.objectType)
        // Ticket DEF1000000958
        const observable = this.insurableObject?.objectType === ContractInsurableObjectType.OBJECT
          ? this.insurableObjectService.postObjectImage(id, dto)
          : this.insurableObject?.objectType === ContractInsurableObjectType.ME
            ? this.userApiService.updatePhoto(dto)
            : this.insurableObjectService.postPersonImage(id, dto);

        observable.subscribe({
          next: () => {
            this.imageSrc = this.tempImageSrc;
            this.messageService.add({
              severity: 'success',
              summary: 'Bild aktualisiert',
              detail: 'Das Bild wurde erfolgreich aktualisiert.'
            });
            this.dashboardService.changeRequest(this.createInitialRequest());
          },
          error: (error) => {
            console.error('image upload error =>', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Fehler',
              detail: 'Bild-Upload fehlgeschlagen.'
            });
          }
        });
      });
    }).catch(error => {
      console.error('image resize error =>', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Fehler',
        detail: 'Bild-Upload fehlgeschlagen.'
      });
    });

  }


  handleDeleteImage() {
    this.imageSrc = undefined;
    if (this.insurableObject) {
      (this.insurableObject.imageUrl as any) = undefined;
      (this.insurableObject.imageType as any) = undefined;
    }
  }

  dataURItoBlob(dataURI: string): Blob {
    const [header, base64] = dataURI.split(',');
    const mime = header.match(/:(.*?);/)?.[1];

    if (!base64 || !mime) {
      throw new Error('Invalid data URI format');
    }

    const byteString = atob(base64);
    const byteArray = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      byteArray[i] = byteString.charCodeAt(i);
    }

    return new Blob([byteArray], { type: mime });
  }

  convertFileToBase64AndGetType(file: File): Promise<{ fileBase64: string; fileBase64MimeType: string; name: string }> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = function (event) {
        const result = event.target?.result;
        const base64 = typeof result === 'string' ? result.split(',')[1] : '';
        resolve({
          fileBase64: base64,
          fileBase64MimeType: file.type,
          name: file.name
        });
      };
      reader.onerror = error => reject(error);
      reader.readAsDataURL(file);
    });
  }

  resetFileInput() {
    const input: HTMLInputElement = document.getElementById('upload') as HTMLInputElement;
    if (input) {
      input.value = '';
    }
  }


}
